import { useState } from "react";
import MobileAppAuth from "./mobile-app-auth";
import TelegramAuth from "./telegram-auth";
import { useAppSelector } from "src/redux/redux-hooks";
import { telegramAuthOff } from "src/api/securityAuthApi";
import { showErrorToast, showSuccessToast } from "src/utils/toast";
import TelegramAuthOff from "./telegram-auth-off";

const SecurityAuthView = () => {
  const [currentTab, setCurrentTab] = useState<number>(0);
  const { userData } = useAppSelector((state) => state.user);
  const [loading, setLoading] = useState<boolean>(false);
  const [otpSend, setOtpSend] = useState<boolean>(false);

  const getCodeForOff = () => {
    if (userData && userData?.is_telegram_auth) {
      setLoading(true);
      telegramAuthOff()
        .then(() => {
          showSuccessToast("Sucessfully Code Generate.");
          setOtpSend(true);
        })
        .catch((error) => {
          const message = error?.data?.status_message ?? "Something went wrong";
          showErrorToast(message);
        })
        .finally(() => setLoading(false));
    } else if (userData && userData?.is_two_factor_authentication) {
      setLoading(true);
      setOtpSend(true);
      setLoading(false);
    }
  };

  const isEnabled = userData ? userData?.is_telegram_auth || userData.is_two_factor_authentication : false;

  return (
    <div className="security-auth">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0 font-size-18">Secure Auth Verification</h4>
            <div className="page-title-right">&nbsp;</div>
          </div>
        </div>
      </div>

      <div>
        <div className="card-body">
          <div className="text-center">
            <b>Secure Auth Verification Status:</b>{" "}
            {!isEnabled ? (
              <span className="badge badge-danger">Disabled</span>
            ) : (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  getCodeForOff();
                }}
                title="Click here to disable secure auth verification"
                className="btn btn-success"
              >
                Enabled
              </a>
            )}
          </div>
          {!isEnabled ? (
            <>
              <div className="mt-2 text-center">Please select below option to enable secure auth verification</div>

              <div className="casino-report-tabs mt-3">
                <ul className="nav nav-tabs">
                  <li className="nav-item pointer">
                    <a
                      href="#"
                      className={`nav-link${currentTab === 0 ? " active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setCurrentTab(0);
                      }}
                    >
                      Enable Using Google
                    </a>
                  </li>
                  <li className="nav-item pointer">
                    <a
                      href="#"
                      className={`nav-link${currentTab === 1 ? " active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setCurrentTab(1);
                      }}
                    >
                      Enable Using Telegram
                    </a>
                  </li>
                </ul>
              </div>

              <div className="tab-content mt-4">
                {currentTab === 0 ? (
                  <div className="tab-pane mobile-app active">
                    <MobileAppAuth />
                  </div>
                ) : (
                  <div className="tab-pane telegram active">
                    <TelegramAuth />
                  </div>
                )}
              </div>
            </>
          ) : (
            <TelegramAuthOff loading={loading} otpSend={otpSend} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SecurityAuthView;
